import { useTranslation } from "./Localization";

export default function OrientationGuard() {
  const { t } = useTranslation();

  return (
    <aside className="orientation-guard" role="alert" aria-live="assertive">
      <div className="orientation-phone" aria-hidden="true">
        <span />
      </div>
      <p>{t("orientation.message")}</p>
    </aside>
  );
}
